import * as Sentry from '@sentry/nextjs'

// Check if Sentry should be enabled (defaults to false in development)
const isSentryEnabled =
	process.env.NEXT_PUBLIC_SENTRY_ENABLED === 'true' || process.env.NODE_ENV === 'production'

/**
 * Captures an API error to Sentry with standardized tags and context.
 * Call this in catch blocks before returning error responses.
 * Respects NEXT_PUBLIC_SENTRY_ENABLED flag - disabled by default in development.
 */
export function captureApiError(
	error: unknown,
	context: {
		endpoint: string
		extra?: Record<string, any>
		tags?: Record<string, string>
	}
): void {
	if (!isSentryEnabled) {
		console.error('[Sentry] Error not captured (Sentry disabled):', {
			endpoint: context.endpoint,
			error: error instanceof Error ? error.message : String(error),
			tags: context.tags,
			extra: context.extra,
		})
		return
	}

	Sentry.captureException(error, {
		level: 'error',
		tags: {
			errorType: 'api_error',
			endpoint: context.endpoint,
			...context.tags,
		},
		extra: {
			errorMessage: error instanceof Error ? error.message : String(error),
			...context.extra,
		},
	})
}
